import axios from "axios";
const endpoint = process.env.VUE_APP_BASE_API + "/api/master/fare-component";

export default {
  async getPreBookingComponent() {
    return await axios
      .get(`${endpoint}/pre-booking`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getPostBookingComponent() {
    return await axios
      .get(`${endpoint}/post-booking`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/master/fareComponent.js